<template>
	<div>
		<div class="mes_wrap" ref="wrap" :class="{'is_system':is_system}">

			<loading class="loadbox" loadType="small" :title="'正在加载中...'" v-show="isLoading && hasMore"></loading>
			<no-data msg="没有更多数据了" v-if="!hasMore"></no-data>
			
			<div v-for="(item,i) in list" :key="item.id">

				<!-- 时间 -->
				<div :class="['m_time','m_item'+item.id]" v-if="item.space_time">{{item.space_time}}</div>

				<!-- 撤回的消息 -->
				<li v-if="item.statues == 'withdraw'" class="message_with_draw">
                    <p>
						{{item.content}}
						<button
							v-if="item.show_re_edit_button == 'yes' && item.content_type == 'text'"
							class="withdrawBtn"
							:data-id="qa.id"
							:data-current_user="qa.user_id"
							:data-opposite_user="qa.accept_user_id"
						>重新编辑</button>
					</p>
                </li>

				<!-- 正常消息(排除小秘书 系统管理员) -->
				<div 
					v-else-if="!item.jump_kind"
					:class="['m_item','m_item'+item.id, item.user_id && item.user_id == user.userId ? 'm_r' : '']"
				>
					<div class="m_img">
						<img :src="item.avatar" alt="">
					</div>
					<i></i>
					<!-- 文字 -->
					<div v-if="item.content_type == 'text'" class="m_content m_5" v-html="brightenKeyword && brightenKeyword(item.content, [])"></div>
					<!-- 图片 -->
					<div v-else-if="item.content_type == 'image'" class="m_content">
						<!-- <imgList
							v-if=" item.content "
							:image="[item.content] || []"
							:video="[]"
						/> -->
						<img 
							class="live_img"
							:src="item.content"
							@load="$previewRefresh"
                    		:preview="randomStr"
						/>
					</div>
					<!-- 其他 -->
					<div v-else class="m_content">暂不支持查看，请下载爱股圈APP</div>
				</div>

				<!-- 小秘书的 问答列表-->
				<!-- mes-ques 
					v-if="(item.is_system_question == 'yes' && questions_type.forum_user == item.content) || (item.is_system_msg == 'yes')" 
					:id="item.id"
					:h1="questions_frame_info.frame2.forum_user"
					:questions_list="questions_list.forum_user"
					:secImg="secImg"
					@sendQ="sendQ"
				>
				</mes-ques -->


				<!-- 系统管理员 支付提醒 -->
				<!-- mes-system :data="item" v-if="item.jump_kind"></mes-system -->


			</div>
			
			<div v-if="wait_for_prompt" class="wait_for_prompt">
				{{ wait_for_prompt }}
			</div>
		</div>

		<div class="mes_reply" v-if="!is_system" ref="mes_reply">
			<div class="mes_input" @click="()=>{this.focus_ipt = true}">{{ comIptInfo }}</div>
			<div class="mes_btn">
				<label for="fileToUploadv_1"></label>
				<input type="file" class="fileToUploadv_1-3" id="fileToUploadv_1" accept="image/*">
			</div>
		</div>


		<div class="publish_wrap" v-show="focus_ipt">
			<div class="publish_box" :class="{ publish_box_focus: focus_ipt }">
				<div
					class="input_box"
					:class="{ focus_ipt: focus_ipt }"
				>
					<textarea
						ref="send_content"
						cols="30"
						rows="10"
						:placeholder="comIptInfo"
						v-model="send_content"
					></textarea>
				</div>
				<div class="comment_wrap_mes">
					<div class="comment_btn" @click="send('text')">发布</div>
				</div>
			</div>
		</div>
		<div
			class="publish_mask"
			v-if="focus_ipt"
			@click.stop="
				() => {
					focus_ipt = false;
					send_content = '';
				}
			"
		></div>

        <!-- 滚动到底部的提示 -->
        <div class="h_agq_page_bottom_tip" v-if="is_show_bottom_tip" @click.stop.prevent="fixedBottom">{{ unread }}条消息</div>
	</div>

</template>

<script>
	import {brightenKeyword} from "@/utils/publicCommon";
	import mesApi from "@/api/message";
	import myApi from "@/api/my";
	import mesQues from './components/mesQues.vue';
	import mesSystem from './components/mesSystem.vue';
	import imgList from "@/components/imgList";
	import TIM from 'tim-js-sdk';
	import TIMUploadPlugin from 'tim-upload-plugin';	
	import COS from 'cos-js-sdk-v5';
	import noData from "@/components/noData"
	import loading from "@/components/loading"

    export default {
        name: "mes",
		components:{
			mesQues,
			imgList,
			mesSystem,
			noData,
			loading
		},
		data(){
        	return{
				opposite_user : this.$route.params.id,
				list:[],
				hasMore: true,
				isLoading: false,
				compare_to: 0,
				focus_ipt: false,
				send_content: "",
				comIptInfo: "说点什么…",
				can_send:1,
				send_src:'',
				user:{},//
				message:'',
				last_id:0,
				questions_frame_info:{},
				questions_list:{},
				questions_type:{},
				secImg:'http://img1-cdn-picsh.stock-ring.com/express/2020-11-5/4_1604570776911_0=300X300.jpg',
				randomStr: Math.random().toString(36).slice(-4),
				brightenKeyword,
				unread: 0, // 未读数
				is_show_bottom_tip: false, // 默认异常

				// 是否展示 今天内容页已经发送三条
				wait_for_prompt: "",
				// 判断用户身份
				user_role: "",
			}
		},
		watch: {
			'$store.state.user': {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					console.info(val,'VAL_', this.user, 'userINFO')
					if(val.userId && val.user_app_token && Object.keys(this.user).length == 0) {
						// 初始化

						this.user = val;

						this.getIVToken();
						
						// 获取私信信息
						this.getDate(this.compare_to);
					}
				}
			}
		},
		computed:{
			is_system(){
				//是否是系统消息：管理员 系统通知
				if(this.$route.params.id == 998 || this.$route.params.id == 999){
					return true;
				}
				else{
					return false;
				}
			},
			is_sectery(){
				//是否是小秘书
				if(this.$route.params.id == 1000){
					return true;
				}
				else{
					return false;
				}
			},
		},
		mounted(){
			let _this = this;
			this.wheelDom();

			$(".fileToUploadv_1-3").bind('change', function (e) {
				console.info('啛啛喳喳')
				// 文件不存在则返回
				if(!e.target.files) return;

				let file = e.target.files[0];

				var file_type = '';
				if (/^image/.test(file.type)) {
					file_type = 'image';
				}

				var objURL = _this.getObjectURL(file);
				// 获取64
				_this.getBase64(objURL).then(function (base64) {
					let _base64 = base64.substring(base64.indexOf(",") + 1);
					let obj = {
						content: base64,
						image: _base64,
						user_id: _this.user.userId,
						content_type: "image",
						id: _this.user.userId,
						avatar: _this.user.avatarImgPath,
						nick_name: _this.user.userName,
						sort_time: new Date().getTime() / 1000,
						withdraw: "wait",
						_up_type: 'loading'
					}
					_this.send_src = _base64;

					_this.list.push(obj);
					
					_this.send("image");
					_this.$nextTick(()=>{
						setTimeout(()=>{
							let wrap = _this.$refs.wrap;
							wrap.scrollTop = 999999;
						}, 700)
					//  $('#detail_list ul').scrollTop(99999999);
					})

				}, function (err) {
					console.log(err);//打印异常信息
				});
			})
		},
		methods:{
			// 获取文件对象 转换成它的url暂缓地址
			getObjectURL(file) {
				var url = null;
				if (window.createObjcectURL != undefined) {
					url = window.createOjcectURL(file);
				} else if (window.URL != undefined) {
					url = window.URL.createObjectURL(file);
				} else if (window.webkitURL != undefined) {
					url = window.webkitURL.createObjectURL(file);
				}
				return url;
			},
			//传入图片路径，返回base64
			getBase64(img) {
				function getBase64Image(img, width, height) {//width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
					var canvas = document.createElement("canvas");
					canvas.width = width ? width : img.width;
					canvas.height = height ? height : img.height;
					var ctx = canvas.getContext("2d");
					ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
					var dataURL = canvas.toDataURL();
					return dataURL;
				}
				var image = new Image();
				image.crossOrigin = '';
				image.src = img;
				var deferred = $.Deferred();
				if (img) {
					image.onload = function () {
					deferred.resolve(getBase64Image(image));//将base64传给done上传处理
					}
					return deferred.promise();
				}
			},
			uploadImg() {
				// 上传图片
				console.info('上传图片	')
				// $('.fileToUploadv_1-3').click()
				$("#fileToUploadv_1").click();
			},
			//监听滚动到顶部，加载更多对话
			wheelDom() {
				this.$nextTick(() => {
					var wrap = this.$refs.wrap;
					let _this = this;
					wrap.onscroll = () => {
						if (wrap.scrollHeight < (wrap.scrollTop + wrap.clientHeight + 200)){  //滚动条滑到底部啦
							_this.is_show_bottom_tip = false;
							_this.unread = 0;
						}

						if (wrap.scrollTop == 0 && wrap.clientHeight != wrap.scrollHeight) {
							this.columnListMore();
						}
					};
				});
			},
			//滚动到对话框底部
			srcoll_bottom() {
				//为了防止图片未加载完就滚动
				setTimeout(() => {
					this.$nextTick(() => {
						var wrap = this.$refs.wrap;
						wrap.scrollTop = wrap.scrollHeight;
						//console.log(wrap.scrollTop,wrap.scrollHeight)
					})

				}, 200);
			},
			//加载数据
        	async getDate(compare_to){
				this.isLoading = true;
        		let res = await mesApi.getMesData({
					opposite_user : this.opposite_user,
					current_user: this.user.userId,
					compare_to: compare_to
				})
				if (res.result === "success") {

					// TOOD  没找到
					// this.wait_for_prompt = res.data.wait_for_prompt;
					// this.user_role = res.data.user_role;

					let list = res.list;


					if (list.length!==0) {

						if(this.list.length > 0){
							this.last_id = this.list[0].id;
						}

						

						//首次加载
						if(this.compare_to == 0){
							this.list = list;
							this.can_send = res.vip_valid && res.vip_valid.can_send || 1;//模拟
							this.message = res.vip_valid && res.vip_valid.message;
							this.questions_frame_info = res.questions_frame_info;
							this.questions_list = res.questions_list;
							this.questions_type = res.questions_type;
							this.srcoll_bottom();
						}
						else{
							this.list = [...list,...this.list];
							let wrap = this.$refs.wrap;
							let mes_reply = this.$refs.mes_reply;
							this.$nextTick(()=>{
								let wrap_top = wrap.querySelector(".m_item"+this.last_id)
								//滑动到固定位置：上次的最后一条 作为 本屏的最后一条
								wrap.scrollTop = wrap_top.getBoundingClientRect().top - ( wrap.clientHeight - mes_reply.clientHeight - wrap_top.clientHeight) ;
								this.last_id = this.list[0].id;
							})
							
						}

						this.compare_to = list[0].sort_time;
						console.log(this.compare_to )

					}

					if (list.length === 0) {
						this.hasMore = false;
					}



				} else {
					this.hasMore = false;
					this.$message.error(res.message);
				}
				this.isLoading = false;
			},
			//加载数据，由于是iv调用的，所以应该是收到了新消息，调用接口，然后比对新数据。后端改不了，前端这边处理一下该方法
        	async getIvData(){
				this.isLoading = true;
        		let res = await mesApi.getMesData({
					opposite_user : this.opposite_user,
					compare_to: 0,
					appversion : '1.4.0',
				})
				if (res.status === "success") {

					let list = res.data.list;

					if (list.length!==0) {

						let _iv_new_list = list, // 接口拿到的新数据
                            _iv_old_list = this.list, // 之前存储的旧数据
                            _iv_add_list = []; // 前两者对比发现的新数据

						// 一开始没有聊天内容话，就直接赋值好了
                        if (_iv_old_list.length === 0) {
							_iv_add_list = _iv_new_list
                        } 
						// 进行比对吧
						else {
                            //双重循环对比列表
							for(let i=0,ilen=_iv_new_list.length;i<ilen;i++) {
								let isExist = false;
								for(let j=0,jlen=_iv_old_list.length;j<jlen;j++) {
									if(_iv_new_list[i].id == _iv_old_list[j].id) {
										isExist = true;
										break;
									}
								}
								if(!isExist) {
									_iv_add_list.push(_iv_new_list[i]);
								}
							}
                        }

						this.list.push(..._iv_add_list);
						if(_iv_add_list.length > 0) {
							this.$nextTick(()=>{
								
								// 滚动到底部，还是现实标签
								let _show = this.elementIsVisibleInViewport($('.mes_wrap>div').last()[0], true);
								if(!_show) {
									this.is_show_bottom_tip = true;
									this.unread+=1
								}
								else {
									this.$nextTick(()=>{
										$(this.$refs['wrap']).scrollTop(999999999);
										$("html, body").scrollTop(999999999)
									})
								}
								this.last_id = this.list[0].id;
							})
						}

						console.info(this.compare_to,'compare_to')
					}
				}
				this.isLoading = false;
			},
			// 定位到底部
			fixedBottom() {
				$(this.$refs['wrap']).scrollTop(99999999999)
				$("html, body").scrollTop(99999999)
				this.is_show_bottom_tip = false;
				this.unread = 0;
			},
			//更多
			async columnListMore() {
				if (this.isLoading || this.compare_to === 0 || !this.hasMore) {
					return;
				}
				await this.getDate(this.compare_to);
			},
			//发布检查
			checkSend(type) {
				if (this.can_send == 1) {
					if (type == "image") {
						return 1;
					} else {
					if (this.send_content.length == 0) {
						return 0;
					} else {
						return 1;
					}
				}
				} else {
					return -1;
				}
			},
			sendQ(obj){
				this.send_content = obj.content;
				this.send(obj.type,obj.qid,obj.answer);
			},
			//发送  内容、 图片
			send(type,qid,answer) {
				let res = this.checkSend(type);
				if (res == 1) {
					this.sendLetter(type,qid,answer);
				} else if (res == -1) {
					this.$message.error(this.message || "暂不可以发送私信");
				} else if (res == 0) {
					this.$message.error("请输入内容");
				}
				
			},
			//清空消息
			clear() {
				this.focus_ipt = false;
				this.send_content = "";
				this.send_src = "";
			},
			//发送私信
			async sendLetter(type,qid,answer) {
				// 纯文字                
				if(type === "text" || type === "question" ||  type === "question2") {
					let _new_card = {
						id: this.user.userId,
						user_id: this.user.userId,
						avatar: this.user.avatarImgPath,
						nick_name: this.user.userName,
						content_type : "text",
						content:this.send_content,
						is_system_question : type == "question2" ? 'yes' :'no',
					}
					
					this.list.push(_new_card);

					console.info(_new_card,'newCard')


					if(type === "question" && this.is_sectery ){
						let _new_card_s = {
							id: 1000,
							avatar: this.secImg,
							nick_name: '爱股圈小秘书',
							content_type : "text",
							content:answer,
						}
						this.list.push(_new_card_s);
					}


					this.srcoll_bottom();
				}

				let _data = {
					to_user: this.opposite_user, //对话的用户id
					type: type, //内容类型      text-文本、 image-图片、 audio-语音
					content: this.send_content, //文本内容      非必须字段
					image: this.send_src, //图片地址      非必须字段
					source: 'pc',
					from_user: this.user.userId
				};

				if(type.includes('question') ){
					_data.type = 'text';
					if(qid) _data.question_id = qid;
				}

        		let res = await mesApi.SendMes(_data);
				console.log(res);
				if (res.result == "success") {
					if(!type.includes('question') ){
						this.$message.success("发送成功");
					}
					this.clear();
					if(type === 'text') {
						setTimeout(() => {
							//重新刷新一下
							this.compare_to = 0;
							this.getDate(this.compare_to);
						}, 1000);
					} else {
						this.list[this.list.length-1]._up_type = null;
						this.list[this.list.length-1].id = res.letter_id;
					}
				} else {
					this.$message.error(res.info);
				}
				this.send_src = "";

			},
			async getIVToken(){
				let _this = this;
				let options = {
					SDKAppID: location.hostname.indexOf('dev') > -1 || location.hostname.indexOf('192.168.1') > -1 ? 1400317686 : 1400630965 // 接入时需要将0替换为您的即时通信应用的 SDKAppID
				};
				let tim = TIM.create(options); // SDK 实例通常用 tim 表示
				let res = await mesApi.getIVToken();
				console.log('getIVToken',res);
				if (res.status == "success") {
					let sDKS = res.data;
					// 登录

					tim.login({
						userID: `igq-${this.user.userId}`,
						userSig: sDKS
					}).then(() => {})
					
					// 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
					tim.setLogLevel(1); // 普通级别，日志量较多，接入时建议使用
					// tim.setLogLevel(1); // release级别，SDK 输出关键信息，生产环境时建议使用
					tim.registerPlugin({ 'cos-js-sdk': COS, 'tim-upload-plugin': TIMUploadPlugin })//注册COS SDK插件
					
					// 监听事件 收到离线消息和会话列表同步完毕通知
					tim.on(TIM.EVENT.SDK_READY, onReadyStateUpdate, this)
					
					// 收到SDK进入not ready状态通知,此时SDK无法正常工作
					tim.on(TIM.EVENT.SDK_NOT_READY, onReadyStateUpdate, this)
					
					// 出错统一处理
					tim.on(TIM.EVENT.ERROR, onError, this)
					
					// 收到推送的消息,遍历event.data获取消息列表数据并渲染到页面
					tim.on(TIM.EVENT.MESSAGE_RECEIVED, messageReceived, this)
					
					function onReadyStateUpdate ({ name }) {
						const isSDKReady = name === TIM.EVENT.SDK_READY ? true : false;
						if (isSDKReady) {
							tim
								.getMyProfile()
								.then(({ data }) => {
									console.info('登录');
								})
								.catch(error => {})
						}
					}
					
					function onError (event) {
						// 网络错误不弹toast && sdk未初始化完全报错
						if (event.data.message && event.data.code && event.data.code !== 2800 && event.data.code !== 2999) {
						console.info('onerror_+_____')
						}
					}
					
					//消息收发
					function messageReceived (event) {
						console.log('消息收发',event)
						setTimeout(() => {
							_this.getIvData();
						}, 1000);
						
					}

				} else {
					//this.$message.error(res.message);
				}
			},
			// 判断dom是否在可视区
			// 第一个参数是element  第二个参数是 是否部分可见也算可见  
			// 设置为false 即有一部份不可见即不可见
			// 设置为true 即部分可见即算是可见
			elementIsVisibleInViewport(el, partiallyVisible = false) {
				const {
					top,
					left,
					bottom,
					right
				} = el.getBoundingClientRect();
				const {
					innerHeight,
					innerWidth
				} = window;
				return partiallyVisible ?
					((top >= 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
					((left >= 0 && left < innerWidth) || (right > 0 && right < innerWidth)) :
					top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
			}
		}
    }
</script>

<style scoped lang="scss">
	.mes_wrap{
		height: 100vh;
		background: #F0F0F0;
		padding: 0 11px 60px; //有发送
		overflow: auto;
		box-sizing: border-box;
		&.is_system{
			padding: 0 11px 11px;
		}
		.m_time{
			text-align: center;
			font-size: 10px;
			font-weight: 400;
			color: #AFAFAF;
			line-height: 44px;
			width: 100%;
		}
		.message_with_draw {
			width: 100%;
			height: auto;
			text-align: center;
			font-size: 12px;
			line-height: 16.5px;
			color: #888;
			padding: 10px 0;
			box-sizing: border-box;
		}
		.m_item{
			display: flex;
			margin-bottom: 22px;
			.m_img{
				width: 40px;
				height: 40px;
				border-radius: 50%;
				margin-right: 11px;
				// background: red;
				>img{
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}
			.m_content{
				max-width: 245px;
				background: #FFFFFF;
				border-radius:  6px;
				padding: 10px 15px;
				font-size: 15px;
				font-weight: 400;
				color: #333333;
				line-height: 22px;
				box-sizing: border-box;
				word-break: break-all;

				>img{
					width: 100px;
					height: auto;
				}
			}
			i{
				width: 6px;
				height: 11.5px;
				margin-top: 13.5px;
				background: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/l_i.png") no-repeat;
				background-size: contain;
			}
			.m_content_msg{
				padding-bottom: 0;

				.m_content_msg_h1{
					display: flex;
				}
				.switch{
					font-size: 11px;
					width: fit-content;
					height: 20px;
					border-radius:  10px;
					border: 0.5px solid #E0E0E0;
					display: inline-block;
					background: url('https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/mes_r.png') no-repeat;
					background-size:9.5px 8px;
					background-position: 4px 6px;
					color: #636363;
					padding-left: 16px;
					padding-right: 5px;
					display: flex;
					align-items: center;
				}

				h1{
					padding-bottom: 11px;
				}
				.m_content_msg_i{
					display: flex;
					justify-content: space-between;
					border-top: 1px solid #EBEBEB;

					>i{
						width: 10px;
						height: 15px;
						display: block;
						background: url('https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/mes_i2.png') no-repeat;
						background-size: 100%;
						margin-right: 3.5px;
					}
					>p{
						
						padding: 11px 0 11px 18px;
						position: relative;
						width: 74%;
						&::before{
							content: "";
							position: absolute;
							width: 4px;
							height: 4px;
							background: #7D7D7D;
							border-radius: 50%;
							left: 5px;
							top: 20px;
						}
					}
				}

			}

		}

		.m_r{
			display: flex;
			flex-direction: row-reverse;
			.m_img{
				margin-right: 0;
				margin-left: 11px;
			}
			.m_content{
				background-color: rgba(250, 227,219, 1);
				// background: #FFD844;
			}
			i{
				background: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/r_i.png") no-repeat;
				background-size: contain;
				display: none;
			}
		}

		.wait_for_prompt {
			text-align: center;
			font-size: 14px;
			font-weight: 400;
			color: #AFAFAF;
			line-height: 44px;
		}
	}
	.mes_reply{
		width: 100%;
		height: 49px;
		background: #FCFCFC;
		position: fixed;
		bottom: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		.mes_input{
			width: 85%;
			border-radius: 16.75px;
			border: 0.5px solid rgba(135, 135, 135, 0.33);
			background: #F2F2F2;
			height: 38px;
			line-height: 38px;
			font-size: 14px;
			outline: none;
			padding-left: 10px;
			box-sizing: border-box;
			color: #B0B0B0;
			display: flex;
			align-items: center;
			box-sizing: border-box;
		}

		.mes_btn {
			width: 43px;
			height: 100%;
			padding:0 10px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: center;

			label {
				width: 23px;
                height: 23px;
                background-repeat: no-repeat;
                background-size: 23px 23px;
                background-color: transparent;
                border: none;
                outline: none;
                background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/image.svg");
			}

			input[type="file"] {
				width: 0;
				height: 0;
				visibility: hidden;
				opacity: 0;
			}
		}
	}



	.publish_wrap {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		z-index: 20;
		.publish_box {
			width: 100%;
			height: 50px;
			border-top: 1px solid #dedfde;
			border-bottom: 1px solid #dedfde;
			background: #F4F5F7;
			display: flex;
			align-items: center;
			padding-left: 10px;

			> .input_box {
				flex: 1;
				height: 40px;
				border: 1px solid #dcdddc;
				color: #939393;
				border-radius: 5px;
				overflow: hidden;
				transition: height 0.3s;
				> textarea {
					width: 100%;
					height: 100%;
					color: #939393;
					border-radius: 5px;
					font-size: 15px;
					padding: 0 10px;
					box-sizing: border-box;
					border: none;
					outline: none;
					line-height: 40px;
					resize: none;
				}
				&.focus_ipt {
					height: 80px;
					> textarea {
						line-height: 25px;
					}
				}
			}

			> .comment_wrap_mes {
				width: 115px;
				padding: 0 0 15px 15px;
				box-sizing: border-box;
				align-self: flex-end;
				.comment_btn {
					width: 70px;
					height: 28px;
					background: #fe484a;
					border: 1px solid #fe484a;
					border-radius: 5px;
					text-align: center;
					line-height: 28px;
					color: #fff;
					font-size: 12px;
				}
			}
			&.publish_box_focus {
				height: 100px;
				transition: height 0.3s;
				> .comment_share {
					display: none;
				}
				> .comment_wrap_mes {
					display: flex;
				}
			}
		}
		.pad {
			background: #ffffff;
			&.is_iphonx_series {
				padding-bottom: 20px;
			}
		}
	}

	.publish_mask {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: 10;
		background: rgba(0, 0, 0, 0.3);
	}

	// 滚动到底部的提示
	.h_agq_page_bottom_tip {
		padding: 7.5px 13px 7.5px 30.5px;
		box-sizing: border-box;
		font-size: 14px;
		line-height: 20px;
		color: #FE484A;
		background-color: #FFFFFF;
		border-radius: 50px 0 0 50px;
		box-shadow: 0 1px 5px 0 rgba(149, 111, 111, 0.36);
		position: fixed;
		right: 0;
		bottom: 77.5px;
		cursor: pointer;
		user-select: none;
		background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/wap/down_arrow.png");
		background-size: 8.5px 9px;
		background-position: 14px center;
		background-repeat: no-repeat;
		white-space: nowrap;
	}

</style>
